module.exports = __webpack_public_path__ + "img/word-qrcode.7ada24a7.png";